import React from 'react'
import styled from 'styled-components'
import { Centralized } from '../../components/Centralized'
import { STYLES } from '../../static/style'

const StyledSchoolDetailsSection = styled.div<{ isShow: boolean }>`
  padding: 0.5rem;
  ${({ isShow }) =>
    !isShow &&
    `
    display: none;
  `}
`

const StyledContent = styled(Centralized)`
  padding: 0;
  border-radius: ${STYLES.BORDER_RADIUS};
  background-color: ${STYLES.COLOR_WHITE};
  box-shadow: 0px 1px 2px #ccc;
`

interface ISchoolDetailsSectionProps {
  className?: string
  children: React.ReactNode
}

const SchoolDetailsSection: React.FC<ISchoolDetailsSectionProps> = ({
  isShow = true,
  className,
  children,
}) => (
  <StyledSchoolDetailsSection isShow={isShow} className={className}>
    <StyledContent>{children}</StyledContent>
  </StyledSchoolDetailsSection>
)

export { SchoolDetailsSection }
